import { Component, EventEmitter, OnInit } from '@angular/core';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { MenuBreadCrumb, TableColumns, TableConfiguration, params } from 'brainloper-ui';
import { TravelRoute } from '../../../../models/localization/travel-route';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { FormControl } from '@angular/forms';


@Component({
    selector: 'app-router',
    templateUrl: './router.component.html',
    styleUrls: ['./router.component.scss'],
    standalone: false
})
export class RouterComponent implements OnInit {

  urlGetRoutes: string =`${EndpointDictionary.TravelRoute.TRAVEL_ROUTER_TABLE}`
  urlRoutes: string =`${EndpointDictionary.TravelRoute.CRUD_TRAVEL_ROUTER}`
  private inactivateRouter: string = `${EndpointDictionary.TravelRoute.INACTIVATE_ROUTER}`;
  private activeRouter: string = `${EndpointDictionary.TravelRoute.ACTIVE_ROUTER}`;


  public selected = new FormControl(0);
  public locationRouteId: number;
  public label: string;

  reloadRouteTable = new EventEmitter<any>()
  reloadRouteInactiveTable = new EventEmitter<any>()
  routeColumnsTable : TableColumns<TravelRoute>[] = [
    {
      ID: 'name',
      label: 'Nombre',
      type: 'text',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'originName',
      label: 'Origen',
      type: 'text',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'endName',
      label: 'Destino',
      type: 'text',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'distance',
      label: 'Distancia(Km)',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'timeHours',
      label: 'Tiempo(Hras)',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'numberCheckPoint',
      label: 'Puntos registrados',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
  ]
  public routeConfigurationTable : TableConfiguration = {
    edit: true,
    add: true,
    delete: false,
    selectable:true,
    addPer: true,
    editPer: true,
    primaryKey: 'id',
    active:true
  }

  public routeConfigurationInactive: TableConfiguration = {
    selectable:true,
    primaryKey: 'id',
    active:true
  }

  public isChecked: boolean = true
  public labelToggle:string = "Rutas activas"

  public params: params[] = [
    {
      id: 'active',
      value: 1
    }]

  public params2: params[] = [
    {
      id: 'active',
      value: 0
    }]


  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
      name:"Rutas",
      current:true
    }
  ]


  constructor(
     private deleteItem: DeleteGenericService,
  ) { }

  ngOnInit(): void {
  }

  public addRouter($event){
    this.locationRouteId = 0;
    this.label = 'Crear Ruta';
    this.selected.setValue(1);
  }

  public editRouter($event:TravelRoute[]){
    this.locationRouteId = $event[0].id
    this.label = 'Actualizar Ruta';
    this.selected.setValue(1);

  //  this.isChecked ? this.reloadRouteTable.emit() : this.reloadRouteInactiveTable.emit()
  }

  async inactivateOrActiveRouter($event: TravelRoute[], active: boolean) {
    if (!Array.isArray($event)) {
      $event = [$event];
    }
    await this.deleteItem.inactivateOrActivate($event, active, this.activeRouter, this.inactivateRouter, 'Ruta')

    if (active) {
      this.reloadRouteInactiveTable.emit()
    } else {
      this.reloadRouteTable.emit()
    }
  }

  changeToggle($event:MatSlideToggleChange){
    if($event.checked){
      this.labelToggle = "Rutas Activas"
    }else{
      this.labelToggle = "Rutas Inactivas"
    }
  }

  completeRouter($event:boolean = true){
    this.selected.setValue(0);
    if($event == true) this.reloadRouteTable.emit();
  }

}
